// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectChimneyStackQueryResult, selectChimneyStacksPageLoading, selectChimneyStacksShowInitWaitingMessage} from '../_selectors/chimney-stack.selectors';

export class ChimneyStacksDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectChimneyStacksPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectChimneyStacksShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectChimneyStackQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
